var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "carousel slide",
      attrs: {
        id: "testimonials-carousel-display",
        "data-ride": "carousel",
        "data-interval": "8000",
      },
    },
    [
      _c(
        "ol",
        { staticClass: "carousel-indicators" },
        _vm._l(_vm.testimonials, function (_, index) {
          return _c("li", {
            key: index,
            class: { active: !index },
            attrs: {
              "data-target": "#testimonials-carousel-display",
              "data-slide-to": index,
            },
          })
        }),
        0
      ),
      _c(
        "div",
        {
          staticClass:
            "carousel-inner text-center py-5 py-md-0 d-flex align-items-center",
        },
        _vm._l(_vm.testimonials, function (testimonial, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "carousel-item",
              class: { active: !index },
            },
            [
              _c("div", { staticClass: "container-lg py-4 px-5" }, [
                _c("blockquote", { staticClass: "blockquote text-center" }, [
                  _c("p", { staticClass: "mb-0" }, [
                    _vm._v(_vm._s(testimonial.text[_vm.T.locale])),
                  ]),
                  _c("footer", { staticClass: "blockquote-footer mt-3" }, [
                    _vm._v(" " + _vm._s(testimonial.author.name) + ", "),
                    _c(
                      "cite",
                      {
                        attrs: {
                          title: testimonial.author.title[_vm.T.locale],
                        },
                      },
                      [_vm._v(_vm._s(testimonial.author.title[_vm.T.locale]))]
                    ),
                  ]),
                ]),
              ]),
            ]
          )
        }),
        0
      ),
      _c(
        "a",
        {
          staticClass: "carousel-control-prev",
          attrs: {
            href: "#testimonials-carousel-display",
            role: "button",
            "data-slide": "prev",
          },
        },
        [
          _c("span", {
            staticClass: "carousel-control-prev-icon",
            attrs: { "aria-hidden": "true" },
          }),
          _c("span", { staticClass: "sr-only" }, [
            _vm._v(_vm._s(_vm.T.wordsPrevious)),
          ]),
        ]
      ),
      _c(
        "a",
        {
          staticClass: "carousel-control-next",
          attrs: {
            href: "#testimonials-carousel-display",
            role: "button",
            "data-slide": "next",
          },
        },
        [
          _c("span", {
            staticClass: "carousel-control-next-icon",
            attrs: { "aria-hidden": "true" },
          }),
          _c("span", { staticClass: "sr-only" }, [
            _vm._v(_vm._s(_vm.T.wordsNext)),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }